import React from 'react';

import IncentivesFiltersOccupancyDropdown from './IncentivesFiltersOccupancyDropdown';

const IncentivesFiltersOccupancy = () => {
  return <IncentivesFiltersOccupancyDropdown />;
};

export default IncentivesFiltersOccupancy;
